module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/ShareCopy.6be42ceb.svg";